import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const ItemGroup = ({ items, hasImage = false, unboxed = false, ghost = false }) => {
    const [openItem, setOpenItem] = useState(items[0])
    const [isMounted, setIsMounted] = useState(false)
    
    let groupClassName = 'item-group'
    if (!hasImage) {
        groupClassName += ' item-group--without-image'
    }
    let itemClassName = 'item'
    if (unboxed) {
        itemClassName += ' item--unboxed'
    } else if (ghost) {
        itemClassName += ' item--ghost'
    }

    useEffect(() => {
        setIsMounted(true)
        setOpenItem(items[0])
    }, [items])

    if (!isMounted) {
        return null;
    }

    return (
        <div className={groupClassName}>
            {hasImage && openItem?.icon &&
                <div className="item-group__image hidden-lg" key={`desktop-img-${openItem?.id}`}>
                    <GatsbyImage
                        alt={openItem?.icon.alternativeText}
                        image={getImage(openItem?.icon.localFile)}
                        placeholder="blurred"
                        quality={100}
                    />
                </div>
            }
            <div className="item-group__items">
                {
                    items.map((item, index) => {
                        return (
                            <div className={`${itemClassName} ${item.id === openItem?.id ? "item--active" : ""}`} onClick={() => setOpenItem(item)} key={index}>
                                <div className="item__header">
                                    {unboxed &&
                                        <>
                                            <i className="icon-check-circle"></i>
                                            <h5>{item.title}</h5>
                                        </>}
                                    {!unboxed &&
                                        <>
                                            <div className="item__header__title">{item.title}</div>
                                            <i className="icon-chevron-down"></i>
                                        </>
                                    }
                                </div>
                                <div className="item__body">
                                    <ReactMarkdown children={item.description} rehypePlugins={[rehypeRaw]} />
                                    {hasImage &&
                                        <div className="item__body__image show-lg" key={`mobile-img-${item?.id}`}>
                                            <GatsbyImage
                                                alt={openItem?.icon.alternativeText}
                                                image={getImage(openItem?.icon.localFile)}
                                                placeholder="blurred"
                                                quality={100}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default ItemGroup